import { Redirect, Route, RouteProps, useLocation } from 'react-router';
import SiderTemplate from '@/components/template/common/SiderTemplate';
import { useSelector } from 'react-redux';
import { RootState } from '@/rootReducer';
import { useAppDispatch } from '@/store';
import { logout, setPrevPage } from '@/features/account/accountSlice';
import { PATH_AUTH_LOGIN } from '@/constants/constant';
import PermissionDeniedPage from '@/components/pages/common/PermissionDeniedPage';
import { Spin } from 'antd';

interface PrivateRoutePropsType extends RouteProps {
  minRole?: string;
  b2b?: boolean;
}

const PrivateRoute = (props: PrivateRoutePropsType) => {
  const dispatch = useAppDispatch();
  const { loading, user } = useSelector((state: RootState) => state.account);
  const location = useLocation();
  const { minRole, b2b } = props;

  if (loading) {
    return <Spin />;
  }

  if (!user) {
    console.log(location.pathname);
    dispatch(setPrevPage(location.pathname));
    return <Redirect to={PATH_AUTH_LOGIN} />;
  }

  if (minRole && !user.role?.includes(minRole)) {
    return <PermissionDeniedPage />;
  }

  if (b2b) {
    if (!user.company) {
      return <Redirect to="/manage/user/info" />;
    }
  }

  return (
    <SiderTemplate user={user} logout={() => dispatch(logout())}>
      <Route {...props} />
    </SiderTemplate>
  );
};

PrivateRoute.defaultProps = {
  minRole: '',
  b2b: false,
};

export default PrivateRoute;
